let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cexyK")).then(() => parcelRequire('5T8Pb'));